import { render } from "./ProcurePageCard.vue?vue&type=template&id=0da9f612&scoped=true"
import script from "./ProcurePageCard.vue?vue&type=script&lang=js"
export * from "./ProcurePageCard.vue?vue&type=script&lang=js"

import "./ProcurePageCard.vue?vue&type=style&index=0&id=0da9f612&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da9f612"]])

export default __exports__